import React from "react";
import BaseField from "components/util/schema_form/fields/BaseField";
import l from "components/util/l";


const ConfirmField = ({
    name,
    label,
    values,
    value,
    required,
    disabled,
    caption,
    confirmLabel = "Confirmar%SC050",
    rejectLabel = "Rechazar%SC051",
    helpMessage,
    setFieldValue
}) => {


    const onConfirm = (event) => {
        setFieldValue(name, true);
    }

    const onReject = (event) => {
        setFieldValue(name, false);
    }

    return (
        <BaseField
            name={name}
            label={label}
            required={required}
            values={values}
            caption={caption}
            helpMessage={helpMessage}
            enableComments={false}
            setFieldValue={setFieldValue}
        >
            <div class="input-group input-group-md-down-break">
                <div class="form-control">
                    <div class="custom-control custom-radio">
                        <input type="radio" class="custom-control-input" name={l(name)} id={`${name}_confirm`} 
                            disabled={disabled} required={required} checked={value == true} onChange={onConfirm} />
                        <label class="custom-control-label" for={`${name}_confirm`}>{l(confirmLabel)}</label>
                    </div>
                </div>

                <div class="form-control">
                    <div class="custom-control custom-radio">
                        <input type="radio" class="custom-control-input" name={l(name)} id={`${name}_reject`} 
                            disabled={disabled} required={required} checked={value == false} onChange={onReject} />
                        <label class="custom-control-label" for={`${name}_reject`}>{l(rejectLabel)}</label>
                    </div>
                </div>
            </div>
        </BaseField>
    )
}

export default ConfirmField;